import ConfirmationPopup from "./component";
export interface ConfirmationPopupConfigParams {
  title?: string;
  contentHtml?: any;
  cancelShown?: boolean;
  cancelLabel?: string;
  onCancel?: any;
  declineShown?: boolean;
  declineLabel?: string;
  onDecline?: any;
  confirmShown?: boolean;
  confirmLabel?: string;
  onConfirm?: any;
  width?: number;
  height?: number;
  isSmallPopup?: boolean;
  autoHeight?: boolean;
}
export default ConfirmationPopup;
